import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { resolveImageUrl, getImageFallback, PLACEHOLDER_IMAGE } from "../../utils/imageUrl";
import { Link } from "react-router-dom";
import LiveViewers from "../LiveViewers";

export function ProductGallery({ product, images, activeImg, setActiveImg, setLightbox, brandLogo, slug, hasDiscount, discountPct }) {
    return (
        <div>
            <div className="relative bg-white rounded-2xl overflow-hidden mb-3 border border-gray-100"
                style={{ paddingBottom: "110%" }}>
                <img
                    src={images[activeImg]}
                    alt={`${product.name}${product.brand ? ` - ${product.brand}` : ""}`}
                    data-original={images[activeImg]}
                    className="absolute inset-0 w-full h-full object-contain p-4 cursor-zoom-in"
                    onClick={() => setLightbox(true)}
                    onError={e => {
                        const fb = getImageFallback(e.target.dataset.original);
                        if (fb && e.target.src !== fb) e.target.src = fb;
                        else { e.target.src = PLACEHOLDER_IMAGE; e.target.onerror = null; }
                    }}
                />
                {hasDiscount && (
                    <div className="absolute top-4 left-4 bg-red-500 text-white text-sm font-bold px-3 py-1.5 rounded-full z-10">
                        -{discountPct}%
                    </div>
                )}
                {product.installation_available && (
                    <div className={`absolute ${hasDiscount ? "top-14" : "top-4"} left-4 text-white text-xs font-medium px-3 py-1.5 rounded-full flex items-center gap-1 z-10`}
                        style={{ backgroundColor: "var(--sg-primary)" }}>
                        <span>Instalace</span>
                    </div>
                )}
                {brandLogo && (
                    <div className="absolute bottom-4 left-4 z-10 bg-white/90 backdrop-blur-sm rounded-xl px-3 py-1.5 shadow-sm border border-gray-100"
                        data-testid="brand-logo-overlay">
                        <Link to={`/kategorie?brand=${product.brand}`} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
                            <img src={brandLogo} alt={product.brand} className="h-8 w-auto object-contain" loading="lazy" data-testid="brand-logo" />
                            <span className="text-xs font-medium text-gray-500">{product.brand}</span>
                        </Link>
                    </div>
                )}
                <div className="absolute top-4 right-4 z-20" data-testid="live-viewers-overlay">
                    <LiveViewers type="product" slug={slug} />
                </div>
                {images.length > 1 && (
                    <>
                        <button onClick={() => setActiveImg(i => (i - 1 + images.length) % images.length)}
                            className="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/90 shadow rounded-full flex items-center justify-center hover:bg-white z-10">
                            <ChevronLeft size={16} />
                        </button>
                        <button onClick={() => setActiveImg(i => (i + 1) % images.length)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/90 shadow rounded-full flex items-center justify-center hover:bg-white z-10">
                            <ChevronRight size={16} />
                        </button>
                    </>
                )}
            </div>
            {images.length > 1 && (
                <div className="flex gap-2.5 overflow-x-auto pb-1">
                    {images.map((img, i) => (
                        <button key={i} onClick={() => setActiveImg(i)}
                            className={`flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden border-2 transition-colors bg-white ${i === activeImg ? "border-green-500 shadow-md" : "border-gray-200 hover:border-gray-300"}`}>
                            <img src={img} alt="" className="w-full h-full object-contain p-1.5"
                                onError={e => { const fb = getImageFallback(img); if (fb && e.target.src !== fb) e.target.src = fb; else { e.target.src = PLACEHOLDER_IMAGE; e.target.onerror = null; } }}
                                loading="lazy" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export function ProductLightbox({ images, activeImg, setActiveImg, onClose }) {
    if (!images?.length) return null;
    return (
        <div className="fixed inset-0 bg-black/90 z-[999] flex items-center justify-center" onClick={onClose}>
            <img src={images[activeImg]} alt="" className="max-w-[90vw] max-h-[90vh] object-contain"
                onClick={e => e.stopPropagation()} />
            {images.length > 1 && (
                <>
                    <button onClick={e => { e.stopPropagation(); setActiveImg(i => (i - 1 + images.length) % images.length); }}
                        className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-white/20">
                        <ChevronLeft size={40} />
                    </button>
                    <button onClick={e => { e.stopPropagation(); setActiveImg(i => (i + 1) % images.length); }}
                        className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-white/20">
                        <ChevronRight size={40} />
                    </button>
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                        {images.map((_, i) => (
                            <button key={i} onClick={e => { e.stopPropagation(); setActiveImg(i); }}
                                className={`w-2.5 h-2.5 rounded-full transition-colors ${i === activeImg ? "bg-white" : "bg-white/40"}`} />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
